module.exports = __webpack_public_path__ + "img/PNI.7bf8d8e2.svg";